module.exports = __webpack_public_path__ + "img/krotoski_wolica.bbef97cc.jpg";